export const DISPLAY_ALERT = 'SHOW_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';

export const SETUP_USER_BEGIN = 'SETUP_USER_BEGIN';
export const SETUP_USER_SUCCESS = 'SETUP_USER_SUCCESS';
export const SETUP_USER_ERROR = 'SETUP_USER_ERROR';

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const LOGOUT_USER = 'LOGOUT_USER';

export const UPDATE_USER_BEGIN = 'UPDATE_USER_BEGIN';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const HANDLE_CHANGE = 'HANDLE_CHANGE';
export const CLEAR_VALUES = 'CLEAR_VALUES';

/* Products */
export const GET_PRODUCTS_BEGIN = 'GET_PRODUCTS_BEGIN';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';

/* Shopping Cart */
export const ADD_PRODUCT_TO_CART_BEGIN = 'ADD_PRODUCT_TO_CART_BEGIN';
export const ADD_PRODUCT_TO_CART_SUCCESS = 'ADD_PRODUCT_TO_CART_SUCCESS';
export const SET_PRODUCT_TO_CART = 'SET_PRODUCT_TO_CART';
export const REMOVE_PRODUCT_TO_CART_BEGIN = 'REMOVE_PRODUCT_TO_CART_BEGIN';
export const REMOVE_PRODUCT_TO_CART_SUCCESS = 'REMOVE_PRODUCT_TO_CART_SUCCESS';
export const CLEAR_CART_BEGIN = 'CLEAR_CART_BEGIN';
export const CLEAR_CART_SUCCESS = 'CLEAR_CART_SUCCESS';

/* Checkout */
export const CC_PAYMENT_BEGIN = 'CC_PAYMENT_BEGIN';
export const CC_PAYMENT_SUCCESS = 'CC_PAYMENT_SUCCESS';
export const CC_PAYMENT_ERROR = 'CC_PAYMENT_ERROR';

/* Jobs */
export const CREATE_JOB_BEGIN = 'CREATE_JOB_BEGIN';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const CREATE_JOB_ERROR = 'CREATE_JOB_ERROR';

export const GET_JOBS_BEGIN = 'GET_JOBS_BEGIN';
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS';

export const SET_EDIT_JOB = 'SET_EDIT_JOB';

export const DELETE_JOB_BEGIN = 'DELETE_JOB_BEGIN';
export const DELETE_JOB_ERROR = 'DELETE_JOB_ERROR';

export const EDIT_JOB_BEGIN = 'EDIT_JOB_BEGIN';
export const EDIT_JOB_SUCCESS = 'EDIT_JOB_SUCCESS';
export const EDIT_JOB_ERROR = 'EDIT_JOB_ERROR';

export const SHOW_STATS_BEGIN = 'SHOW_STATS_BEGIN';
export const SHOW_STATS_SUCCESS = 'SHOW_STATS_SUCCESS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CHANGE_PAGE = 'CHANGE_PAGE';

export const GET_CURRENT_USER_BEGIN = 'GET_CURRENT_USER_BEGIN';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
